import ProfileService from "../services/profile.service";

export const fetchProfileData = async (accessToken) => {
  const profileService = new ProfileService();
  const profile = await profileService.getUserProfile(accessToken);
  return profile;
}